import { useEffect, useState } from "react";
import { getPaymentStatus } from "./paymentApi";
import {
  clearMerchantOrderId,
  clearPaymentReturnPath,
  getMerchantOrderIdFromUrlOrSession,
  getPaymentReturnPath,
  isPhonePeCompleted,
  setPhonePePaymentResult,
} from "./paymentSession";
import "./payment.css";

const STATUS_STYLES = {
  loading: "payment-status-box payment-status-box--loading",
  COMPLETED: "payment-status-box payment-status-box--completed",
  FAILED: "payment-status-box payment-status-box--failed",
  PENDING: "payment-status-box payment-status-box--pending",
  error: "payment-status-box payment-status-box--failed",
};

export default function PaymentStatusPage() {
  const [orderId, setOrderId] = useState("");
  const [state, setState] = useState("loading");
  const [amount, setAmount] = useState(null);
  const [error, setError] = useState("");
  const [rawResponse, setRawResponse] = useState(null);
  const [returnPath, setReturnPath] = useState(() => getPaymentReturnPath());

  useEffect(() => {
    const merchantOrderId = getMerchantOrderIdFromUrlOrSession();
    setOrderId(merchantOrderId || "");

    if (!merchantOrderId) {
      setState("error");
      setError("Order ID not found. Please start payment again.");
      return;
    }

    async function checkStatus() {
      try {
        const data = await getPaymentStatus(merchantOrderId);
        setRawResponse(data);
        const statusObj = data.status || {};
        setAmount(statusObj.amount);
        setState(statusObj.state || "error");

        if (isPhonePeCompleted(statusObj)) {
          setPhonePePaymentResult(statusObj);
          clearMerchantOrderId();
          const savedReturnPath = getPaymentReturnPath();
          setReturnPath(savedReturnPath);
          clearPaymentReturnPath();
          if (savedReturnPath) {
            window.setTimeout(() => {
              window.location.href = savedReturnPath;
            }, 1500);
          }
        }
      } catch (err) {
        setState("error");
        setError(err.message);
      }
    }

    checkStatus();
  }, []);

  const rupees = amount ? (amount / 100).toFixed(2) : null;

  return (
    <div className="payment-status-page">
      <h2>Payment Status</h2>

      <div className={STATUS_STYLES[state] || STATUS_STYLES.loading}>
        {state === "loading" && <p>Checking your payment...</p>}

        {isPhonePeCompleted({ state }) && (
          <>
            <h3>Payment Successful</h3>
            <p>Amount paid: ₹{rupees}</p>
            <p>Payment successful. Returning you to continue…</p>
          </>
        )}

        {state === "FAILED" && (
          <>
            <h3>Payment Failed</h3>
            <p>Please try again.</p>
          </>
        )}

        {state === "PENDING" && (
          <>
            <h3>Payment Pending</h3>
            <p>Your payment is still being processed. Refresh this page in a moment.</p>
          </>
        )}

        {state === "error" && <p>{error}</p>}
      </div>

      {orderId && <p>Order ID: {orderId}</p>}

      {rawResponse && (
        <details className="payment-status-debug">
          <summary>Full payment object (debug)</summary>
          <pre>{JSON.stringify(rawResponse, null, 2)}</pre>
        </details>
      )}

      <p>
        {returnPath ? (
          <>
            <a href={returnPath}>← Back to continue</a>
            {" · "}
          </>
        ) : null}
        <a href="/">Home</a>
      </p>
    </div>
  );
}
